<template>
<div class="simple-page">
  <HeadNav selectedLanguage="en" page="disclaimer" />

  <main class="simple-page__main">
    <h1>Disclaimer</h1>
    <p>
      The information provided on Secure VPN is for general informational purposes only. While we aim to provide accurate and updated content, we cannot guarantee that all information is complete or suitable for every user.
    </p>

    <section>
      <h2>VPN Usage</h2>
      <p>
        VPN services can help improve online privacy and connection security. Users are responsible for using VPN services according to applicable laws and regulations in their region.
      </p>
      <p>
        Secure VPN does not encourage or support illegal activities conducted through VPN services.
      </p>
    </section>

    <section>
      <h2>Third-Party Services</h2>
      <p>
        This website may mention or link to third-party applications, products, or services. We are not responsible for their performance, security, or privacy practices.
      </p>
    </section>

    <section>
      <h2>No Professional Advice</h2>
      <p>
        The content on this website should not be considered legal, technical, or security advice. Users should make decisions based on their own needs.
      </p>
    </section>

    <section>
      <h2>Contact</h2>
      <p>
        For questions about this Disclaimer, please contact us through our
        <router-link to="/contact-us/">Contact Us</router-link>
        page.
      </p>
    </section>
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  components: {
    HeadNav,
  },
  mounted() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('vpn-site');
    }
  },
};
</script>

<style lang="scss" scoped>
.simple-page {
  min-height: 70vh;
  background: #fff;
}

.simple-page__main {
  width: var(--vpn-content-width);
  margin: 0 auto;
  padding: 56px 0 72px;
  color: var(--vpn-ink-muted, #5b6475);
}

h1 {
  margin: 0 0 32px;
  color: var(--vpn-ink, #1f2430);
  font-size: 42px;
  line-height: 1.15;
  font-weight: 800;
}

section {
  margin: 0 0 34px;
}

h2 {
  margin: 0 0 14px;
  color: var(--vpn-ink, #1f2430);
  font-size: 26px;
  line-height: 1.25;
  font-weight: 800;
}

p {
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.75;
}

a {
  color: var(--vpn-brand, #6d4aff);
  font-weight: 700;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .simple-page__main {
    width: 100%;
    padding: 40px 16px 56px;
    box-sizing: border-box;
  }

  h1 {
    font-size: 34px;
  }

  h2 {
    font-size: 23px;
  }
}
</style>
